import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button';
import { ChevronLeftIcon, ChevronRightIcon } from '@navikt/aksel-icons';
import { Paragraph } from '../Paragraph';
import classes from './Pagination.module.css';

type PaginationProps = {
  pageNumber: number;
  setPageNumber: React.Dispatch<React.SetStateAction<number>>;
  totalPages: number;
};

export const Pagination = ({
  pageNumber,
  setPageNumber,
  totalPages,
}: PaginationProps) => {
  const { t } = useTranslation();

  return (
    <div className={classes.paginationContainer}>
      <Button
        variant="primary"
        size="small"
        disabled={pageNumber === 1}
        onClick={() => setPageNumber((prev) => (prev === 1 ? 1 : prev - 1))}
        title={t('pagination.previousPage')}
        aria-label={t('pagination.previousPage')}
      >
        <ChevronLeftIcon aria-hidden="true" fontSize="1.2rem" />
      </Button>

      <Paragraph size="md" className={classes.pageNumber}>
        {t('pagination.pageOf', { current: pageNumber, total: totalPages })}
      </Paragraph>

      <Button
        disabled={pageNumber === totalPages}
        variant="primary"
        size="small"
        onClick={() =>
          setPageNumber((prev) => (prev === totalPages ? totalPages : prev + 1))
        }
        title={t('pagination.nextPage')}
        aria-label={t('pagination.nextPage')}
      >
        <ChevronRightIcon aria-hidden="true" fontSize="1.2rem" />
      </Button>
    </div>
  );
};
